<template>
    <b-modal v-if="!loading" id="incident_form" ref="incident_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            {{ !edit ? 'Add New Incident' : 'Edit Incident' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>
            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Priority">
                        <b-row>
                            <b-colxx md="6">
                                <b-form-checkbox
                                    @input="'urgent' in errors ? delete errors.urgent : ''"
                                    v-model="form.urgent">Urgent</b-form-checkbox>
                            </b-colxx>

                            <b-colxx md="6">
                                <b-form-checkbox
                                    @input="'life_threatening' in errors ? delete errors.life_threatening : ''"
                                    v-model="form.life_threatening">
                                    Life threatening
                                </b-form-checkbox>
                            </b-colxx>
                        </b-row>

                        <b-form-invalid-feedback :state="!'priority' in errors"
                                                 v-text="'priority' in errors ? errors.priority[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Housing Type" class="has-float-label">
                        <template v-slot:label>
                            <span>Housing Type <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.housing_type" :class="{'border-danger': 'housing_type' in errors}"
                                      @input="'housing_type' in errors ? delete errors.housing_type : ''"
                                      autocomplete="off" placeholder="Housing Type"/>

                        <b-form-invalid-feedback :state="!'housing_type' in errors"
                                                 v-text="'housing_type' in errors ? errors.housing_type[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="Date" class="has-float-label">
                        <template v-slot:label>
                            <span>Date <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-align="left" popover-visibility="focus" mode="single"
                            v-model="datepicker.date" @input="'date' in errors ? delete errors.date : ''"
                            :input-props="{ class:'form-control' + ('date' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>


                        <b-form-invalid-feedback :state="!'date' in errors"
                                                 v-text="'date' in errors ? errors.date[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Time" class="has-float-label">
                        <template v-slot:label>
                            <span>Time <sup><code>*</code></sup></span>
                        </template>

                        <v-timepicker v-model="form.time" format="hh:mm A" placeholder="HH:MM AM/PM"
                                      hour-label="HOUR" minute-label="MINUTE" second-label="SECOND"
                                      apm-label="AM/PM" am-text="AM" pm-text="PM" close-on-complete
                                      :input-class="{'border-danger': 'time' in errors}"
                                      @input="'time' in errors ? delete errors.time : ''"/>

                        <b-form-invalid-feedback :state="!'time' in errors"
                                                 v-text="'time' in errors ? errors.time[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Facility" class="has-float-label">
                        <template v-slot:label>
                            <span>Facility <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateFacility" v-model="selected.facility" :options="facilities"
                                  :border-danger="'facility_id' in errors"/>

                        <b-form-invalid-feedback :state="!'facility_id' in errors"
                                                 v-text="'facility_id' in errors ? errors.facility_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Type of Incident" class="has-float-label">
                        <template v-slot:label>
                            <span>Type of Incident <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.incident_type" :class="{'border-danger': 'incident_type' in errors}"
                                      @input="'incident_type' in errors ? delete errors.incident_type : ''"
                                      autocomplete="off" placeholder="Type of Incident"/>

                        <b-form-invalid-feedback :state="!'incident_type' in errors"
                                                 v-text="'incident_type' in errors ? errors.incident_type[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx xxs="12">
                    <b-row>
                        <b-colxx xxs="12" class="mb-2">
                            <span>Any Persons Involved?</span>
                        </b-colxx>
                    </b-row>

                    <b-row>
                        <b-colxx xxs="2" class="mb-2">
                            <toggle-button v-model="form.involved" @input="checkInvolved" :value="true" :height="28" :width="58"
                                           :labels="{checked: 'YES', unchecked: 'NO'}"
                                           :color="{checked: '#28A745', unchecked: '#8F8F8F'}"/>
                        </b-colxx>

                        <b-colxx v-if="form.involved" xxs="10" class="mb-2">
                            <h6>
                                <b-badge variant="outline-success">
                                    {{ "Please add persons involved below" }}
                                </b-badge>
                            </h6>
                        </b-colxx>
                    </b-row>
                </b-colxx>
            </b-row>

            <div v-if="form.involved">
                <b-card class="mb-4" no-body>
                    <b-tabs v-model="involvedTabIndex" card>
                        <b-tab v-for="(person, i) in form.involvedData" :key="'involved-tab-' + i"
                               :title="(i+1).toString()">
                            <b-row>
                                <b-colxx md="12">
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend>
                                            <b-button disabled variant="outline-secondary">{{ "P-" +
                                            (i+1) }}
                                            </b-button>
                                        </b-input-group-prepend>

                                        <b-form-input type="text" v-model="person.name" :class="{'border-danger': 'involvedData.' + i +'.name' in errors}"
                                                      :style="{'z-index': 'involvedData.' + i +'.name' in errors ? 2 : 'auto'}"
                                                      @input="'involvedData.' + i +'.name' in errors ? delete errors['involvedData.' + i + '.name'] : ''"
                                                      autocomplete="off" placeholder="Person's Name *"/>

                                        <b-form-invalid-feedback :state="!'involvedData.' + i + '.name' in errors"
                                                                 v-text="'involvedData.' + i +'.name' in errors ? errors['involvedData.' + i + '.name'][0] : ''"/>
                                    </b-input-group>
                                </b-colxx>
                            </b-row>

                            <b-row>
                                <b-colxx md="6">
                                    <b-form-group label="Type" class="has-float-label">
                                        <template v-slot:label>
                                            <span>Type <sup><code>*</code></sup></span>
                                        </template>

                                        <b-form-input type="text" v-model="person.type" :class="{'border-danger': 'involvedData.' + i + '.type' in errors}"
                                                      @input="'involvedData.' + i + '.type' in errors ? delete errors['involvedData.' + i + '.type'] : ''"
                                                      autocomplete="off" placeholder="Type of Involvement *"/>

                                        <b-form-invalid-feedback :state="!'involvedData.' + i + '.type' in errors"
                                                                 v-text="'involvedData.' + i +'.type' in errors ? errors['involvedData.' + i + '.type'][0] : ''"/>
                                    </b-form-group>
                                </b-colxx>

                                <b-colxx md="6">
                                    <b-form-group label="Gender" class="has-float-label">
                                        <template v-slot:label>
                                            <span>Gender <sup><code>*</code></sup></span>
                                        </template>

                                        <template v-if="selected.genders[i]">
                                            <b-form-select v-model="selected.genders[i].value"
                                                           @change="updateInvolvedGender({...{value: $event}, i})" plain>
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>Genders</b-form-select-option>
                                                </template>

                                                <b-form-select-option v-for="(gender, index) in genders" :key="index"
                                                                      :value="gender.value">
                                                    {{ gender.label }}
                                                </b-form-select-option>
                                            </b-form-select>
                                        </template>
                                    </b-form-group>

                                    <b-form-invalid-feedback
                                        :state="!'involvedData.' + i + '.gender' in errors"
                                        v-text="'involvedData.' + i + '.gender' in errors ? errors['involvedData.' + i + '.gender'][0] : ''"/>
                                </b-colxx>
                            </b-row>

                            <b-row>
                                <b-colxx md="4">
                                    <b-form-group label="Date of Birth" class="has-float-label">
                                        <template v-slot:label>
                                            <span>Date of Birth <sup><code>*</code></sup></span>
                                        </template>

                                        <v-date-picker
                                            popover-align="left" popover-visibility="focus" mode="single"
                                            v-model="person.dob" @input="'involvedData.' + i + '.dob' in errors ? delete errors['involvedData.' + i + '.dob'] : ''"
                                            :input-props="{ class: 'form-control' + ('involvedData.' + i + '.dob' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>
                                    </b-form-group>

                                    <b-form-invalid-feedback
                                        :state="!'involvedData.' + i + '.dob' in errors"
                                        v-text="'involvedData.' + i + '.dob' in errors ? errors['involvedData.' + i + '.dob'][0] : ''"/>
                                </b-colxx>

                                <b-colxx md="8">
                                    <b-input-group class="mb-3">
                                        <b-form-input type="text" v-model="person.ssn" :class="{'border-danger': 'involvedData.' + i + '.ssn' in errors}"
                                                      @input="'involvedData.' + i + '.ssn' in errors ? delete errors['involvedData.' + i + '.ssn'] : ''"
                                                      autocomplete="off" v-mask="'###-##-###'" placeholder="SSN *"/>

                                        <b-input-group-append>
                                            <b-button @click.prevent="removeInvolvedTab(i)" variant="secondary" :disabled="i === 0">
                                                Delete
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                    <b-form-invalid-feedback
                                        :state="!'involvedData.' + i + '.ssn' in errors"
                                        v-text="'involvedData.' + i + '.ssn' in errors ? errors['involvedData.' + i + '.ssn'][0] : ''"/>
                                </b-colxx>
                            </b-row>
                        </b-tab>

                        <template v-slot:tabs-end>
                            <b-nav-item @click.prevent="newInvolvedTab" href="#"><b>+</b></b-nav-item>
                        </template>
                    </b-tabs>
                </b-card>
            </div>

            <b-row>
                <b-colxx xxs="12">
                    <b-row>
                        <b-colxx xxs="12" class="mb-2">
                            <span>Any Emergency Responders?</span>
                        </b-colxx>
                    </b-row>

                    <b-row>
                        <b-colxx xxs="2" class="mb-2">
                            <toggle-button v-model="form.responder" @input="checkResponder" :value="true" :height="28" :width="58"
                                           :labels="{checked: 'YES', unchecked: 'NO'}"
                                           :color="{checked: '#28A745', unchecked: '#8F8F8F'}"/>
                        </b-colxx>
                        <b-colxx v-if="form.responder" xxs="10" class="mb-2">
                            <h6>
                                <b-badge variant="outline-success">
                                    {{ "Please add emergency responders below" }}
                                </b-badge>
                            </h6>
                        </b-colxx>
                    </b-row>
                </b-colxx>
            </b-row>

            <div v-if="form.responder">
                <b-card class="mb-4" no-body>
                    <b-tabs v-model="responderTabIndex" card>
                        <b-tab v-for="(responder, i) in form.responderData"
                               :key="'responder-tab-' + i"
                               :title="(i+1).toString()">
                            <b-row>
                                <b-colxx md="12">
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend>
                                            <b-button disabled variant="outline-secondary">{{ "E-" +
                                            (i+1) }}
                                            </b-button>
                                        </b-input-group-prepend>

                                        <b-form-input type="text" v-model="responder.name" :class="{'border-danger': 'responderData.' + i + '.name' in errors}"
                                                      :style="{'z-index': 'responderData.' + i +'.name' in errors ? 2 : 'auto'}"
                                                      @input="'responderData.' + i + '.name' in errors ? delete errors['responderData.' + i + '.name'] : ''"
                                                      autocomplete="off" placeholder="Responder's Name *"/>

                                        <b-form-invalid-feedback :state="!'responderData.' + i + '.name' in errors"
                                                                 v-text="'responderData.' + i +'.name' in errors ? errors['responderData.' + i + '.name'][0] : ''"/>
                                    </b-input-group>
                                </b-colxx>
                            </b-row>

                            <b-row>
                                <b-colxx md="6">
                                    <b-form-group label="Badge" class="has-float-label">
                                        <template v-slot:label>
                                            <span>Badge <sup><code>*</code></sup></span>
                                        </template>

                                        <b-form-input type="text" v-model="responder.badge" :class="{'border-danger': 'responderData.' + i + '.badge' in errors}"
                                                      @input="'responderData.' + i + '.badge' in errors ? delete errors['responderData.' + i + '.badge'] : ''"
                                                      autocomplete="off" placeholder="Badge"/>

                                        <b-form-invalid-feedback :state="!'responderData.' + i + '.badge' in errors"
                                                                 v-text="'responderData.' + i +'.badge' in errors ? errors['responderData.' + i + '.badge'][0] : ''"/>
                                    </b-form-group>
                                </b-colxx>

                                <b-colxx md="6">
                                    <b-form-group label="Unit" class="has-float-label">
                                        <template v-slot:label>
                                            <span>Unit <sup><code>*</code></sup></span>
                                        </template>

                                        <b-form-input type="text" v-model="responder.unit" :class="{'border-danger': 'responderData.' + i + '.unit' in errors}"
                                                      @input="'responderData.' + i + '.unit' in errors ? delete errors['responderData.' + i + '.unit'] : ''"
                                                      autocomplete="off" placeholder="Unit"/>

                                        <b-form-invalid-feedback :state="!'responderData.' + i + '.unit' in errors"
                                                                 v-text="'responderData.' + i +'.unit' in errors ? errors['responderData.' + i + '.unit'][0] : ''"/>
                                    </b-form-group>
                                </b-colxx>
                            </b-row>

                            <b-row>
                                <b-colxx md="6">
                                    <b-form-group label="Time Called" class="has-float-label">
                                        <template v-slot:label>
                                            <span>Time Called <sup><code>*</code></sup></span>
                                        </template>

                                        <v-timepicker v-model="responder.time_called" format="hh:mm A" placeholder="HH:MM AM/PM"
                                                      hour-label="HOUR" minute-label="MINUTE" second-label="SECOND"
                                                      apm-label="AM/PM" am-text="AM" pm-text="PM" close-on-complete
                                                      :input-class="{'border-danger': 'responderData.' + i + '.time_called' in errors}"
                                                      @input="'responderData.' + i + '.time_called' in errors ? delete errors['responderData.' + i + '.time_called'] : ''"/>

                                        <b-form-invalid-feedback :state="!'responderData.' + i + '.time_called' in errors"
                                                                 v-text="'responderData.' + i +'.time_called' in errors ? errors['responderData.' + i + '.time_called'][0] : ''"/>
                                    </b-form-group>
                                </b-colxx>

                                <b-colxx md="6">
                                    <b-form-group label="Time Arrived" class="has-float-label">
                                        <template v-slot:label>
                                            <span>Time Arrived <sup><code>*</code></sup></span>
                                        </template>

                                        <v-timepicker v-model="responder.time_arrived" format="hh:mm A" placeholder="HH:MM AM/PM"
                                                      hour-label="HOUR" minute-label="MINUTE" second-label="SECOND"
                                                      apm-label="AM/PM" am-text="AM" pm-text="PM" close-on-complete
                                                      :input-class="{'border-danger': 'responderData.' + i + '.time_arrived' in errors}"
                                                      @input="'responderData.' + i + '.time_arrived' in errors ? delete errors['responderData.' + i + '.time_arrived'] : ''"/>

                                        <b-form-invalid-feedback :state="!'responderData.' + i + '.time_arrived' in errors"
                                                                 v-text="'responderData.' + i +'.time_arrived' in errors ? errors['responderData.' + i + '.time_arrived'][0] : ''"/>
                                    </b-form-group>
                                </b-colxx>
                            </b-row>

                            <b-row>
                                <b-colxx md="4">
                                    <b-form-group label="Responder" class="has-float-label">
                                        <template v-slot:label>
                                            <span>Responder <sup><code>*</code></sup></span>
                                        </template>

                                        <template v-if="selected.responders[i]">
                                            <b-form-select v-model="selected.responders[i].value"
                                                           @change="updateResponderType({...{value: $event}, i})" plain>
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>Responders</b-form-select-option>
                                                </template>

                                                <b-form-select-option v-for="(responder, index) in responders" :key="index"
                                                                      :value="responder.value">
                                                    {{ responder.label }}
                                                </b-form-select-option>
                                            </b-form-select>
                                        </template>

                                        <b-form-invalid-feedback :state="!'responderData.' + i + '.responder' in errors"
                                                                 v-text="'responderData.' + i +'.responder' in errors ? errors['responderData.' + i + '.responder'][0] : ''"/>
                                    </b-form-group>
                                </b-colxx>

                                <b-colxx md="8">
                                    <b-input-group class="mb-3">
                                        <b-form-input type="text" v-model="responder.comments" :class="{'border-danger': 'responderData.' + i + '.comments' in errors}"
                                                      @input="'responderData.' + i + '.comments' in errors ? delete errors['responderData.' + i + '.comments'] : ''"
                                                      autocomplete="off" placeholder="Comments *"/>

                                        <b-input-group-append>
                                            <b-button @click.prevent="removeResponderTab(i)" variant="secondary" :disabled="i === 0">
                                                Delete
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                    <b-form-invalid-feedback
                                        :state="!'responderData.' + i + '.comments' in errors"
                                        v-text="'responderData.' + i + '.comments' in errors ? errors['responderData.' + i + '.comments'][0] : ''"/>
                                </b-colxx>
                            </b-row>
                        </b-tab>

                        <template v-slot:tabs-end>
                            <b-nav-item @click.prevent="newResponderTab" href="#"><b>+</b></b-nav-item>
                        </template>
                    </b-tabs>
                </b-card>
            </div>

            <b-row>
                <b-colxx xxs="12">
                    <b-row>
                        <b-colxx xxs="12" class="mb-2">
                            <span>Any Person(s) Injured?</span>
                        </b-colxx>
                    </b-row>

                    <b-row>
                        <b-colxx xxs="2" class="mb-2">
                            <toggle-button v-model="form.injury" @input="checkInjury" :value="true" :height="28" :width="58"
                                           :labels="{checked: 'YES', unchecked: 'NO'}"
                                           :color="{checked: '#28A745', unchecked: '#8F8F8F'}"/>
                        </b-colxx>

                        <b-colxx v-if="form.injury" xxs="10" class="mb-2">
                            <h6>
                                <b-badge variant="outline-success">
                                    {{ "Please add injury details below" }}
                                </b-badge>
                            </h6>
                        </b-colxx>
                    </b-row>
                </b-colxx>
            </b-row>

            <div v-if="form.injury">
                <b-card class="mb-4" no-body>
                    <b-tabs v-model="injuryTabIndex" card>
                        <b-tab v-for="(injury, i) in form.injuryData"
                               :key="'injury-tab-' + i"
                               :title="(i+1).toString()">
                            <b-row>
                                <b-colxx md="12">
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend>
                                            <b-button disabled variant="outline-secondary">{{ "P-" +
                                            (i+1) }}
                                            </b-button>
                                        </b-input-group-prepend>

                                        <b-form-input type="text" v-model="injury.name" :class="{'border-danger': 'injuryData.' + i +'.name' in errors}"
                                                      :style="{'z-index': 'injuryData.' + i +'.name' in errors ? 2 : 'auto'}"
                                                      @input="'injuryData.' + i +'.name' in errors ? delete errors['injuryData.' + i + '.name'] : ''"
                                                      autocomplete="off" placeholder="Person's Name *"/>

                                        <b-form-invalid-feedback :state="!'injuryData.' + i + '.name' in errors"
                                                                 v-text="'injuryData.' + i +'.name' in errors ? errors['injuryData.' + i + '.name'][0] : ''"/>
                                    </b-input-group>
                                </b-colxx>
                            </b-row>

                            <b-row>
                                <b-colxx md="6">
                                    <b-form-group label="Type" class="has-float-label">
                                        <template v-slot:label>
                                            <span>Type <sup><code>*</code></sup></span>
                                        </template>

                                        <b-form-input type="text" v-model="injury.type" :class="{'border-danger': 'injuryData.' + i + '.type' in errors}"
                                                      @input="'injuryData.' + i + '.type' in errors ? delete errors['injuryData.' + i + '.type'] : ''"
                                                      autocomplete="off" placeholder="Type of Injury *"/>

                                        <b-form-invalid-feedback :state="!'injuryData.' + i + '.type' in errors"
                                                                 v-text="'injuryData.' + i +'.type' in errors ? errors['injuryData.' + i + '.type'][0] : ''"/>
                                    </b-form-group>
                                </b-colxx>

                                <b-colxx md="6" class="d-flex flex-row mb-3">
                                    <b-form-group class="my-auto">
                                        <b-form-checkbox v-model="injury.moved_to_hospital">
                                            {{ "Moved to hospital" }}
                                        </b-form-checkbox>
                                    </b-form-group>
                                </b-colxx>
                            </b-row>

                            <b-row>
                                <b-colxx md="12">
                                    <b-input-group class="mb-3">
                                        <b-form-input type="text" v-model="injury.hospital_name" :class="{'border-danger': 'injuryData.' + i +'.hospital_name' in errors}"
                                                      @input="'injuryData.' + i +'.hospital_name' in errors ? delete errors['injuryData.' + i + '.hospital_name'] : ''"
                                                      autocomplete="off" placeholder="Hospital Name"/>

                                        <b-input-group-append>
                                            <b-button @click.prevent="removeInjuryTab(i)"
                                                      variant="secondary" :disabled="i === 0">
                                                Delete
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                    <b-form-invalid-feedback :state="!'injuryData.' + i + '.hospital_name' in errors"
                                                             v-text="'injuryData.' + i +'.hospital_name' in errors ? errors['injuryData.' + i + '.hospital_name'][0] : ''"/>
                                </b-colxx>
                            </b-row>
                        </b-tab>

                        <template v-slot:tabs-end>
                            <b-nav-item @click.prevent="newInjuryTab" href="#"><b>+</b></b-nav-item>
                        </template>
                    </b-tabs>
                </b-card>
            </div>

            <b-row class="mt-2">
                <b-colxx md="12">
                    <b-form-group label="Description" class="has-float-label">
                        <template v-slot:label>
                            <span>Description <sup><code>*</code></sup></span>
                        </template>

                        <b-form-textarea v-model="form.description" rows="6" :class="{'border-danger': 'description' in errors}"
                                         @input="'description' in errors ? delete errors.description : ''" placeholder="Description"/>

                        <b-form-invalid-feedback :state="!'description' in errors"
                                                 v-text="'description' in errors ? errors.description[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Action Taken" class="has-float-label">
                        <template v-slot:label>
                            <span>Action Taken <sup><code>*</code></sup></span>
                        </template>

                        <b-form-textarea v-model="form.action_taken" rows="6" :class="{'border-danger': 'action_taken' in errors}"
                                         @input="'action_taken' in errors ? delete errors.action_taken : ''" placeholder="Action Taken"/>

                        <b-form-invalid-feedback :state="!'action_taken' in errors"
                                                 v-text="'action_taken' in errors ? errors.action_taken[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Resident/Security Officer Statement (When Applicable)">
                        <b-form-checkbox v-model="form.res_statements" value="Resident statement">Resident statement</b-form-checkbox>
                        <b-form-checkbox v-model="form.res_statements" value="Resident refused to offer comment">Resident refused to offer comment</b-form-checkbox>
                        <b-form-checkbox v-model="form.res_statements" value="Resident unable to provide statement due to medical or emergency reason">Resident unable to provide statement due to medical/emergency reason</b-form-checkbox>
                        <b-form-checkbox v-model="form.res_statements" value="Security officer report">Security officer report</b-form-checkbox>
                        <b-form-checkbox v-model="form.other_statement" @input="checkOtherStatement">Other</b-form-checkbox>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row v-if="form.other_statement">
                <b-colxx md="12">
                    <b-form-group label="Other" class="has-float-label">
                        <b-form-input type="text" v-model="form.res_other" :class="{'border-danger': 'res_other' in errors}"
                                      @input="'res_other' in errors ? delete errors.res_other : ''"
                                      autocomplete="off" placeholder="Other"/>

                        <b-form-invalid-feedback :state="!'res_other' in errors"
                                                 v-text="'res_other' in errors ? errors.res_other[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row class="mb-4">
                <b-colxx md="12">
                    <vue-dropzone ref="fileDropZone" id="dropzone"
                                  @vdropzone-error="attachmentError"
                                  :destroy-dropzone="false" :options="dropzoneOptions"/>
                </b-colxx>
            </b-row>

            <b-row v-if="edit">
                <b-colxx md="12">
                    <FilesList v-if="form.attachments" :edit="true" :files="form.attachments.data" @delete="deleteFile"/>
                </b-colxx>
            </b-row>

            <b-row class="mb-n4">
                <b-colxx md="4">
                    <b-form-group label="Prepared By" class="has-float-label">
                        <template v-slot:label>
                            <span>Prepared By <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.prepared_by" :class="{'border-danger': 'prepared_by' in errors}"
                                      @input="'prepared_by' in errors ? delete errors.prepared_by : ''"
                                      autocomplete="off" placeholder="Prepared By"/>

                        <b-form-invalid-feedback :state="!'prepared_by' in errors"
                                                 v-text="'prepared_by' in errors ? errors.prepared_by[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="4">
                    <b-form-group label="Title" class="has-float-label">
                        <template v-slot:label>
                            <span>Title <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.prepared_title" :class="{'border-danger': 'prepared_title' in errors}"
                                      @input="'prepared_title' in errors ? delete errors.prepared_title : ''"
                                      autocomplete="off" placeholder="Title"/>

                        <b-form-invalid-feedback :state="!'prepared_title' in errors"
                                                 v-text="'prepared_title' in errors ? errors.prepared_title[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="4">
                    <b-form-group label="Date" class="has-float-label">
                        <template v-slot:label>
                            <span>Date <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-align="right" popover-visibility="focus" mode="single"
                            v-model="datepicker.prepared_date" @input="'prepared_date' in errors ? delete errors.prepared_date : ''"
                            :input-props="{ class:'form-control' + ('prepared_date' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>


                        <b-form-invalid-feedback :state="!'prepared_date' in errors"
                                                 v-text="'prepared_date' in errors ? errors.prepared_date[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('incident_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitIncident">Submit</state-button>

            <state-button v-else variant="primary" :click="updateIncident">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";
import VueTimepicker from 'vue2-timepicker';
import VueDropzone from 'vue2-dropzone';
import {mapGetters} from "vuex";
import moment from "moment";
import FilesList from "../../../../../components/Listing/FilesList";

export default {
    name: "IncidentFormModal",

    components: {
        FilesList,
        StateButton,
        'v-timepicker': VueTimepicker,
        VueDropzone
    },

    props: [
        'edit'
    ],

    data() {
        return {
            loading: true,
            involvedTabIndex: 0,
            responderTabIndex: 0,
            injuryTabIndex: 0,
            datepicker: {
                date: null,
                prepared_date: null,
            },
            selected: {
                facility: [],
                genders: [],
                responders: [],
            },
            genders: [
                {label: 'Male', value: 'Male'},
                {label: 'Female', value: 'Female'},
                {label: 'Other', value: 'Other'},
            ],
            responders: [
                {label: 'NYPD', value: 'NYPD'},
                {label: 'EMS', value: 'EMS'},
                {label: 'FDNY', value: 'FDNY'},
            ],
            deleted_attachments: [],
            dropzoneOptions: {
                url: 'url',
                thumbnailHeight: 160,
                acceptedFiles: '.jpg,.jpeg,.png,.pdf',
                maxFilesize: 10,
                previewTemplate: this.dropzoneTemplate(),
                headers: {
                    'Authorization': 'Bearer ' + this.$store.getters.accessToken
                },
                dictDefaultMessage: 'Drop or Click here to upload files.<br>Max file size 10MB.<br>Accepted file types: JPG, JPEG, PNG, PDF.',
                autoProcessQueue: false
            },
        }
    },

    computed: {
        ...mapGetters({
            facilities: 'getSelectFacilities',
            form: 'getIncidentForm',
            errors: 'getIncidentErrors',
        }),
    },

    watch: {
        form() {
            if (this.edit) {
                this.datepicker.date = moment(this.form.date).toDate();
                this.datepicker.prepared_date = moment(this.form.prepared_date).toDate();

                this.selected.facility = this.form.select_facility;

                if (this.form.involvedData.length) {
                    this.form.involvedData = this.form.involvedData.map((involve) => {
                        this.selected.genders.push(involve.select_gender);

                        return {
                            ...involve,
                            dob: moment(involve.dob).toDate()
                        }
                    });
                }

                if (this.form.responderData.length) {
                    this.form.responderData.map((responder) => {
                        this.selected.responders.push(responder.select_responder);
                    });
                }
            }
        },

        'datepicker.date'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.date = null;
            this.form.date = moment(date).format('YYYY-MM-DD');
        },

        'datepicker.prepared_date'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.prepared_date = null;
            this.form.prepared_date = moment(date).format('YYYY-MM-DD');
        }
    },

    mounted() {
        this.getFormData();
    },

    methods: {
        async getFormData() {
            await this.$store.dispatch('fetchSelectFacilities');

            return this.loading = false;
        },

        submitIncident() {
            return new Promise((success, fail) => {
                this.$store.dispatch('submitIncident', this.form)
                    .then(response => {
                        this.uploadFiles(response.data);
                    })
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Added new incident!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('incident_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        updateIncident() {
            let payload = {
                ...this.form,
                deleted_attachments: this.deleted_attachments,
            };

            return new Promise((success, fail) => {
                this.$store.dispatch('updateIncident', payload)
                    .then(response => {
                        this.uploadFiles(response.data);
                    })
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Updated the incident!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('incident_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        uploadFiles(incident) {
            let url = '/api/hms/compliances/incidents' + incident.incident_id + '/attachments';

            this.$refs.fileDropZone.setOption('url', url);

            this.$refs.fileDropZone.processQueue(incident);
        },

        deleteFile(file) {
            this.deleted_attachments.unshift(file);
            this.form.attachments.data.splice(file.index, 1);
        },

        updateFacility(field) {
            if (field) {
                this.form.facility_id = field.facility_id;
            } else {
                this.form.facility_id = '';
            }
            'facility_id' in this.errors ? delete this.errors.facility_id : '';
        },

        checkOtherStatement() {
            if(!this.form.other_statement) {
                this.form.res_other = '';
            }
        },

        attachmentError(file, message, xhr) {
            this.$refs.fileDropZone.removeFile(file);
            this.$notify('error filled', 'Error!', file.name + " could not be added!", {
                duration: 6000,
                permanent: false
            });
        },

        dropzoneTemplate() {
            return `<div class="dz-preview dz-file-preview mb-3">
                  <div class="d-flex flex-row "> <div class="p-0 w-30 position-relative">
                      <div class="dz-error-mark"><span><i></i>  </span></div>
                      <div class="dz-success-mark"><span><i></i></span></div>
                      <div class="preview-container">
                        <img data-dz-thumbnail class="img-thumbnail border-0" />
                        <i class="simple-icon-doc preview-icon"></i>
                      </div>
                  </div>
                  <div class="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
                    <div> <span data-dz-name /> </div>
                    <div class="text-primary text-extra-small" data-dz-size /> </div>
                    <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                    <div class="dz-error-message"><span data-dz-errormessage></span></div>
                  </div>
                  <a href="#" class="remove" data-dz-remove> <i class="glyph-icon simple-icon-trash"></i> </a>
                </div>`
        },

        checkInvolved() {
            if (!this.form.involved) {
                this.$store.commit('resetIncidentInvolvedData');
            }
        },

        newInvolvedTab() {
            this.form.involvedData.push({
                type: '',
                name: '',
                gender: '',
                ssn: '',
                dob: null,
            });

            this.selected.genders.push({
                value: null,
                label: "Gender",
            });

            setTimeout(() => {
                this.involvedTabIndex++;
            }, 1);
        },

        updateInvolvedGender(field) {
            if (field.value) {
                this.form.involvedData[field.i].gender = field.value;
            } else {
                this.form.involvedData[field.i].gender = '';
            }

            'involvedData.' + field.i + '.gender' in this.errors ? delete this.errors['involvedData.' + field.i + '.gender'] : '';
        },

        removeInvolvedTab(index) {
            this.form.involvedData.splice(index, 1);
        },

        checkResponder() {
            if (!this.form.responder) {
                this.$store.commit('resetIncidentResponderData');
            }
        },

        newResponderTab() {
            this.form.responderData.push({
                name: '',
                responder: '',
                time_called: '',
                time_arrived: '',
                badge: '',
                unit: '',
                comments: '',
            });

            this.selected.responders.push({
                value: null,
                label: "Responder",
            });

            setTimeout(() => {
                this.responderTabIndex++;
            }, 1);
        },

        updateResponderType(field) {
            if (field.value) {
                this.form.responderData[field.i].responder = field.value;
            } else {
                this.form.responderData[field.i].responder = '';
            }

            'responderData.' + field.i + '.responder' in this.errors ? delete this.errors['responderData.' + field.i + '.responder'] : '';
        },

        removeResponderTab(index) {
            this.form.responderData.splice(index, 1);
        },

        checkInjury() {
            if (!this.form.injury) {
                this.$store.commit('resetIncidentInjuryData');
            }
        },

        newInjuryTab() {
            this.form.injuryData.push({
                name: '',
                type: '',
                moved_to_hospital: false,
                hospital_name: '',
            });

            setTimeout(() => {
                this.injuryTabIndex++;
            }, 1);
        },

        removeInjuryTab(index) {
            this.form.injuryData.splice(index, 1);
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        resetForm() {
            this.$store.commit('setIncidentForm');
        },
    }
}
</script>

<style scoped>

</style>
